/*============================= Back To Top Button Script ========================*/
var mybutton = document.getElementById("backTop");
window.onscroll = function () { scrollFunction() };

function scrollFunction() {
    // Check if mybutton exists before accessing style to avoid console errors
    if (mybutton) {
        if (document.body.scrollTop > 120 || document.documentElement.scrollTop > 120) {
            mybutton.style.display = "flex";
        } else {
            mybutton.style.display = "none";
        }
    }
}

function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

window.addEventListener('scroll', function(){ 
    var menubar = document.querySelector("#mainNav"); 
    if (menubar) {
        menubar.classList.toggle("fixed-top", window.scrollY > 100);
    }
});

document.addEventListener('DOMContentLoaded', function() {
    AOS.init({ 
        // Global settings:
        offset: 120, // offset (in px) from the original trigger point
        delay: 50, // values from 0 to 3000, with step 50ms
        duration: 500, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
});
 

(function ($) {
    // Use document ready to ensure DOM is fully loaded before running logic
    $(document).ready(function() {

        // Main Header Nav links Active Class Generator
        $("#mainNav .navbar-nav li a").each(function () {
            var linkUrl = this.href.replace(/\.php$/, "").replace(/\/$/, ""); 
            var currentUrl = location.href.replace(/\.php$/, "").replace(/#.*/, "").replace(/\/$/, ""); 

            if (linkUrl === currentUrl) {
                $(this).closest("li").addClass("active");
            }
        });

        $(".serviceCarousel").owlCarousel({
            autoplay: false, 
            autoplayHoverPause: true,
            smartSpeed: 550,
            autoplayTimeout: 10000,
            autoplaySpeed: 3000,
            loop: false,
            margin: 15,
            items: 3,
            nav: false,
            dots: true,
            responsiveClass: true, 
            responsive: { 
                0: { items: 1, margin: 12 },
                576: { items: 2, margin: 12 },
                768: { items: 2, margin: 15 },
                992: { items: 2, margin: 15 }, 
                1200: { items: 3, margin: 15 }, 
                1400: { items: 3 }, 
            } 
        });

        $(".blogCarousel").owlCarousel({
            autoplay: false, 
            autoplayHoverPause: true,
            smartSpeed: 550,
            autoplayTimeout: 10000,
            autoplaySpeed: 3000,
            loop: false,
            margin: 35,
            items: 3,
            nav: false,
            dots: true,
            responsiveClass: true, 
            responsive: { 
                0: { items: 1, margin: 15 },
                576: { items: 2, margin: 22 },
                768: { items: 2, margin: 25 },
                992: { items: 2, margin: 25 }, 
                1200: { items: 3, margin: 35 }, 
                1400: { items: 3 }, 
            } 
        });

        
        // Contact Form Submission
        $("#contactForm").on("submit", function() {
            return validateContactForm();
        }); 

        function validateContactForm() {
            var valid = true;   
            $(".form-control").css('border-color','');
            $(".error").html('');
            
            var name = $("#name").val();
            var phone = $.trim($('#phone').val());
            var email = $("#email").val();
            var country = $("#country").val();

            // User name validation
            if(!name) {
                $("#name_error").html("Name required");
                $("#name").css('border-color','#dc3545');
                valid = false;
            } else {
                $("#name").css('border-color','#099f1a');
            } 
            
            // Phone validation
            var che_phno = /^[0-9]{7,15}$/;
            if(!phone) {
                $("#phone_error").html("Phone number required");
                $("#phone").css('border-color','#dc3545');
                valid = false;
            } else if (!che_phno.test(phone)) {
                $("#phone_error").html('Please enter valid phone no'); 
                $("#phone").css('border-color','#dc3545');
                valid = false;
            } else {
                $("#phone").css('border-color','#099f1a');
            } 

            // Email validation
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if(!email) {
                $("#email_error").html("Email is required");
                $("#email").css('border-color','#dc3545');
                valid = false;
            } else if(!email.match(emailReg)) {
                $("#email_error").html("Invalid email");
                $("#email").css('border-color','#dc3545');
                valid = false;
            } else {
                $("#email").css('border-color','#099f1a');
            } 
            
            // Country validation
            if(!country) {
                $("#country_error").html("Country required");
                $("#country").css('border-color','#dc3545');
                valid = false;
            } else {
                $("#country").css('border-color','#099f1a');
            } 
                
            return valid;
        } 
    });
})(jQuery);